import axios, { CancelTokenSource } from "axios";
import { useEffect, useState } from "react";

import API_URL from "./apiConfig";

const useFetchData = <T extends unknown>(
    url: string
): { response: T | undefined; loading: boolean; showError: boolean; responseStatus: number | undefined } => {
    const [response, setResponse] = useState<T | undefined>();
    const [responseStatus, setResponseStatus] = useState<number | undefined>();
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);

    const URL = API_URL + url;

    useEffect(() => {
        const cancelToken: CancelTokenSource = axios.CancelToken.source();

        const fetchData = async () => {
            setShowError(false);
            setLoading(true);
            try {
                const result = await axios.request<T>({
                    url: URL,
                    withCredentials: true,
                    cancelToken: cancelToken.token
                });
                setResponseStatus(result.status);
                setResponse(result.data);
            } catch (error) {
                if (!axios.isCancel(error)) {
                    setShowError(true);
                }
            }
            setLoading(false);
        };

        const urlParams = new URLSearchParams(url.split("?")[1]);
        const name = urlParams.get("name") || "";

        let delayTimeout: NodeJS.Timeout | null = null;

        if (name.length < 3) {
            delayTimeout = setTimeout(fetchData, 800);
        } else {
            fetchData();
        }

        return () => {
            if (delayTimeout) clearTimeout(delayTimeout);
            cancelToken.cancel("Request canceled due to new fetch.");
        };
    }, [URL]);

    return {
        response,
        loading,
        showError,
        responseStatus
    };
};

export default useFetchData;
